/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./favCreateTicket.vue?vue&type=template&id=c19160c8&scoped=true"
import script from "./favCreateTicket.vue?vue&type=script&lang=js"
export * from "./favCreateTicket.vue?vue&type=script&lang=js"
import style0 from "./favCreateTicket.vue?vue&type=style&index=0&id=c19160c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19160c8",
  null
  
)

export default component.exports